var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6566 17.0141L17.335 17.3357C16.3417 18.329 12.6684 18.6691 9.00173 15.0024C5.33506 11.3357 5.66833 7.66901 6.66833 6.66901L6.9957 6.34164C7.51628 5.82105 8.38268 5.90718 8.79106 6.51975L10.1378 8.53985C10.4463 9.00258 10.3853 9.61874 9.99206 10.012L9.29303 10.711C9.11446 10.8895 9.05465 11.1531 9.17121 11.3771C9.38368 11.7855 9.82689 12.4942 10.6684 13.3357C11.5099 14.1772 12.2186 14.6204 12.6269 14.8329C12.8509 14.9494 13.1145 14.8896 13.293 14.7111L13.992 14.012C14.3853 13.6188 15.0014 13.5578 15.4641 13.8663L17.4774 15.2084C18.0935 15.6191 18.1801 16.4905 17.6566 17.0141Z",
    fill: "#7B7B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.f13ab7e4aa847d235232b4061d9a4e75.svg";
export { ForwardRef as ReactComponent };